import { DeleteOutlined, EditOutlined } from "@ant-design/icons";
import { Table, Space, Tooltip, Popover, Pagination } from "antd";
import React, { useEffect, useState } from "react";
import DeletePlanGroupApi from "../../api/DeletePlanGroupApi";
import ConfirmationModal from "../modal/ConfirmationModal";
import {
  openNotificationError,
  openNotificationSuccess,
} from "../../helpers/NotificationHelpers";
import moment from "moment";
import EditProgressModal from "../modal/edit/EditProgressModal";
import DeleteTargetProgressApi from "../../api/target-progress/DeleteTargetProgressApi";

function ProgressHistoryTable(props) {
  const [editModal, setEditModal] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteProgressId, setDeleteProgressId] = useState("");
  const [editProgress, setEditProgress] = useState();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(props.loading);
  }, [props.loading]);

  async function deleteProgress() {
    const apiResponse = await DeleteTargetProgressApi(deleteProgressId);
    if (apiResponse.statusCode) {
      openNotificationError("bottomRight", apiResponse.message);
    } else if (apiResponse.message === "success") {
      openNotificationSuccess("bottomRight", "Progress deleted");
      props.handleOk();
    } else {
      openNotificationError("bottomRight", "Couldn't delete. Try again later.");
    }
    setDeleteProgressId("");
  }

  const columns = [
    {
      title: "Date",
      dataIndex: "createdOn",
      key: "createdOn",
      render: (text, record) => (
        <div>{moment(record.createdOn).format("YYYY-MM-DD")}</div>
      ),
    },
    {
      title: "Target",
      dataIndex: "target",
      key: "target",
      render: (text, record) => <div>{record.target}</div>,
    },
    {
      title: "Status",
      dataIndex: "approvalStatus",
      key: "approvalStatus",
      render: (text, record) => <div>{record.approvalStatus}</div>,
    },
    {
      title: "Action",
      key: "action",
      render: (text, record) => (
        <Space size="middle">
          {record.approvalStatus === "Pending" && (
            <Tooltip title={"Edit"}>
              <div
                onClick={() => {
                  setEditModal(true);
                  setEditProgress(record);
                }}
                className="text-blue-500 hover:text-blue-600 cursor-pointer"
              >
                <EditOutlined />
              </div>
            </Tooltip>
          )}
          <Tooltip title={"Delete"}>
            <div
              onClick={() => {
                setDeleteModal(true);
                setDeleteProgressId(record.progressId);
              }}
              className="text-red-500 hover:text-red-600 cursor-pointer"
            >
              <DeleteOutlined />
            </div>
          </Tooltip>
        </Space>
      ),
    },
  ];

  return (
    <>
      <Table
        columns={columns}
        dataSource={props.data}
        pagination={{ position: ["none"] }}
        loading={loading}
      />
      <EditProgressModal
        visible={editModal}
        handleCancel={() => {
          setEditModal(false);
          setEditProgress();
        }}
        progress={editProgress}
        handleOk={() => props.handleOk()}
      />
      <ConfirmationModal
        visible={deleteModal}
        handleCancel={() => {
          setDeleteModal(false);
          setDeleteProgressId("");
        }}
        handleOk={() => deleteProgress()}
        text="Are you sure want to delete this progress?"
        title="Delete progress"
      />
    </>
  );
}

export default ProgressHistoryTable;
